/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UnitDetail model module.
 * @module model/UnitDetail
 * @version 1.0.0
 */
class UnitDetail {
    /**
     * Constructs a new <code>UnitDetail</code>.
     * @alias module:model/UnitDetail
     */
    constructor() { 
        
        UnitDetail.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UnitDetail</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UnitDetail} obj Optional instance to populate.
     * @return {module:model/UnitDetail} The populated <code>UnitDetail</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UnitDetail();

            if (data.hasOwnProperty('room_number')) {
                obj['room_number'] = ApiClient.convertToType(data['room_number'], 'String');
            }
            if (data.hasOwnProperty('floor')) {
                obj['floor'] = ApiClient.convertToType(data['floor'], 'Number');
            }
            if (data.hasOwnProperty('occupied_area_m2')) {
                obj['occupied_area_m2'] = ApiClient.convertToType(data['occupied_area_m2'], 'Number');
            }
            if (data.hasOwnProperty('layout')) {
                obj['layout'] = ApiClient.convertToType(data['layout'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UnitDetail</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UnitDetail</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['room_number'] && !(typeof data['room_number'] === 'string' || data['room_number'] instanceof String)) {
            throw new Error("Expected the field `room_number` to be a primitive type in the JSON string but got " + data['room_number']);
        }
        // ensure the json data is a string
        if (data['layout'] && !(typeof data['layout'] === 'string' || data['layout'] instanceof String)) {
            throw new Error("Expected the field `layout` to be a primitive type in the JSON string but got " + data['layout']);
        }

        return true;
    }


}



/**
 * @member {String} room_number
 */
UnitDetail.prototype['room_number'] = undefined;

/**
 * @member {Number} floor
 */
UnitDetail.prototype['floor'] = undefined;

/**
 * @member {Number} occupied_area_m2
 */
UnitDetail.prototype['occupied_area_m2'] = undefined;

/**
 * @member {module:model/UnitDetail.LayoutEnum} layout
 */
UnitDetail.prototype['layout'] = undefined;





/**
 * Allowed values for the <code>layout</code> property.
 * @enum {String}
 * @readonly
 */
UnitDetail['LayoutEnum'] = {

    /**
     * value: "未選択"
     * @const
     */
    "未選択": "未選択",

    /**
     * value: "1R"
     * @const
     */
    "1R": "1R",

    /**
     * value: "1K"
     * @const
     */
    "1K": "1K",

    /**
     * value: "1LK/1LDK"
     * @const
     */
    "1LK/1LDK": "1LK/1LDK",

    /**
     * value: "2L/2DK"
     * @const
     */
    "2L/2DK": "2L/2DK",

    /**
     * value: "2LK/2LDK"
     * @const
     */
    "2LK/2LDK": "2LK/2LDK",

    /**
     * value: "3K/3DK"
     * @const
     */
    "3K/3DK": "3K/3DK",

    /**
     * value: "3LK/3LDK"
     * @const
     */
    "3LK/3LDK": "3LK/3LDK",

    /**
     * value: "4K/4DK"
     * @const
     */
    "4K/4DK": "4K/4DK",

    /**
     * value: "4LK/4LDK"
     * @const
     */
    "4LK/4LDK": "4LK/4LDK",

    /**
     * value: "5K/5DK"
     * @const
     */
    "5K/5DK": "5K/5DK",

    /**
     * value: "5LK/5LDK"
     * @const
     */
    "5LK/5LDK": "5LK/5LDK",

    /**
     * value: "6K/6DK"
     * @const
     */
    "6K/6DK": "6K/6DK"
};



export default UnitDetail;

